import { StateCreator } from 'zustand';
import { createAppStore } from '@marriott/mi-store-utils';

export interface GiftCardDetails {
  cardCurrency: string;
  cardCurrencyCode: string;
  cardDescription: string;
  cardImageUrl: string | null;
  cardISO: string;
  cardStatus: string;
  certificateBalance: number;
  certificateExpirationDate: string | null;
  hasHoldNotLost: boolean | null;
  isAutoReload: boolean;
  isStoredValue?: boolean;
  pointsBalance: number;
  serialNumber: string;
  createTimestamp?: string;
}
export interface GiftCardDetailsArray extends Array<GiftCardDetails> {}

export interface PersistentGiftCardDetails extends GiftCardDetails {
  cardNumber?: string;
  securityCode?: string;
}

export interface GiftCardState {
  selectedGiftCard?: PersistentGiftCardDetails | null;
  setSelectedGiftCard: (card: PersistentGiftCardDetails | null) => void;
  selectedGiftCardSerialNumber?: string;
  setSelectedGiftCardSerialNumber: (val: string) => void;
  giftCardISOnumber?: string;
  setGiftCardISOnumber: (val: string) => void;
  giftCardSerialnumber?: string;
  setGiftCardSerialnumber: (val: string) => void;
  giftCards?: GiftCardDetails[];
  setProfileGiftCards: (details: GiftCardDetails[]) => void;
  resetGiftCardState: () => void;
}

const initialState: GiftCardState = {
  selectedGiftCard: undefined,
  setSelectedGiftCard: () => {},
  selectedGiftCardSerialNumber: '',
  setSelectedGiftCardSerialNumber: () => {},
  giftCardISOnumber: '',
  setGiftCardISOnumber: () => {},
  giftCardSerialnumber: '',
  setGiftCardSerialnumber: () => {},
  giftCards: undefined,
  setProfileGiftCards: () => {},
  resetGiftCardState: () => {},
};

const GiftCardStore: StateCreator<GiftCardState> = set => {
  return {
    ...initialState,
    setSelectedGiftCard: (card: PersistentGiftCardDetails | null) => {
      set(() => ({
        selectedGiftCard: card,
      }));
    },
    setProfileGiftCards: (details: GiftCardDetails[]) => {
      set({ giftCards: details });
    },
    setSelectedGiftCardSerialNumber: val => {
      set(() => ({
        selectedGiftCardSerialNumber: val,
      }));
    },
    setGiftCardISOnumber: val => {
      set(() => ({
        giftCardISOnumber: val,
      }));
    },
    setGiftCardSerialnumber: val => {
      set(() => ({
        giftCardSerialnumber: val,
      }));
    },
    resetGiftCardState: () => {
      set(initialState);
    },
  };
};

export const useGiftCardStore = createAppStore(GiftCardStore, {
  usePersistentStore: true,
  persistentStoreName: 'GiftCardStore',
});
